import React, { SetStateAction, useContext } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { BodyContext } from '../../../contexts/BodyProvider'
import useCallRestApi from '../../../hooks/useCallRestApi'

type Props = {
  show: boolean,
  closeModal: (value: boolean) => void,
  idCardBIForDelete: number,
  nameCardBIForDelete: string,
  setCardsBI: React.Dispatch<SetStateAction<CardsConectaBI[]>>
}

const ModalDeleteBICard = ({
  show,
  closeModal,
  idCardBIForDelete,
  nameCardBIForDelete,
  setCardsBI

}: Props) => {
  const handleClose = () => closeModal(false)
  const [conectaApi] = useCallRestApi();
  const { loadingAdminBIValue } = useContext(BodyContext);


  const handleDelete = async () => {
    const link: ResourceLink = {
        href: `api/card_bi/${idCardBIForDelete}`,
        rel: "deletar",
        type: "DELETE"
    };
    await conectaApi({
        link: link,
        onSuccess: () => {
          renderList()
          closeModal(false)
        },
        onError: (err) => {
          // message.warn(err.message);
        },
        onFinally: () => {
          //message
        },
    })
    
  }
  const renderList = () => { 
    const link: ResourceLink = {
      href: `api/card_bi`,
      rel: "search",
      type: "GET",
    };

    conectaApi<CardsConectaBI[]>({
      link,
      onSuccess: (Card: CardsConectaBI[]) => {
        loadingAdminBIValue?.setLoadingAdminBI(true)
        setCardsBI(Card);
        loadingAdminBIValue?.setLoadingAdminBI(false)
      },
      onError: (err: ErrorApi) => {},
      onFinally: () => {},
    });
  };
  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Deletar Card BI</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div style={{textAlign:'center'}}>
                <p>Deseja deletar esse Card?</p>
                <h4>{nameCardBIForDelete}</h4>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>Fechar</Button>
            <Button variant="danger" onClick={handleDelete}>Deletar</Button>
        </Modal.Footer>
    </Modal>
  )
}

export default ModalDeleteBICard